import { useCallback, useEffect } from 'react';
import { createFileRoute, Outlet, useChildMatches, useNavigate, useParams } from '@tanstack/react-router';
import { useSelector, useDispatch } from 'react-redux';
import type { RootState } from '../../../../Redux';
import { getTeams } from '../../../../Redux/TeamActions';
import { getContacts } from '../../../../Redux/ChatroomActions';
import TeamList from '../../../../Components/TeamList';
import { classNames } from '../../../../Utils/classnames';

export const Route = createFileRoute('/(main)/_layout/teams/_teams')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { teamId } = useParams({ strict: false });
  const childMatches = useChildMatches();
  const isShowingIndex = childMatches.length === 0;

  const teams = useSelector((state: RootState) => state.team.teams || []);
  const teamsLoading = useSelector((state: RootState) => state.loading.teams || false);
  const contactsLoading = useSelector((state: RootState) => state.loading.contacts || false);
  const contactsOrder = useSelector((state: RootState) => state.chatroom.contactsOrder || []);

  useEffect(() => {
    dispatch(getTeams());
  }, [dispatch]);

  useEffect(() => {
    // Teams create/edit flows depend on contacts being loaded for Add People.
    if (!contactsLoading && contactsOrder.length === 0) {
      dispatch(getContacts());
    }
  }, [dispatch, contactsLoading, contactsOrder.length]);

  const handleTeamSelect = useCallback(
    (teamId: number) => {
      navigate({ to: '/teams/$teamId', params: { teamId } });
    },
    [navigate],
  );

  return (
    <div className={classNames('teams-content', { 'showing-team': !isShowingIndex })}>
      <div className="team-list">
        <TeamList
          teams={teams}
          teamsLoading={teamsLoading}
          selectedTeamId={teamId ? Number(teamId) : null}
          onTeamSelect={handleTeamSelect}
        />
      </div>
      <div className="teams-main">
        {isShowingIndex ? (
          <div className="teams-main-empty">
            <p>Select a team to view members</p>
          </div>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
}
